import { Directive, OnInit, HostListener } from "@angular/core";

@Directive({
  selector: "[appAbcn]"
})
export class ABCNDirective implements OnInit {
  constructor() { }

  error: boolean = false;

  ngOnInit(): void {
    // console.log("abn format directive init ready");
  }

  @HostListener("blur", ["$event"])
  blur(event: Event) {
    // console.log("catch the event from keyboard: ", event.target);

    /*
    TODO I disable this function right now , has some problem.

    const input = event.target as HTMLInputElement;
    //console.log('I am blur this input ', input.value);
    console.log('the lentgh of th einput area is : ', input.value.length);
    //
    let trimmed = input.value.replace(/\s+/g, "");


    let numbers = [];
    for (let i = 0; i < trimmed.length; i += 4) {
      numbers.push(trimmed.substr(i, 4));
    }
    // console.log("now the input is :", trimmed,"---", input.value);
    // note I dinot do anything here, but it automacitally fixed by itself,
    // before, when i input 123156  -> 1231 65
    // but
    input.value = numbers.join(" ");

    console.log(input.value);
    */
  }
}



// WEBPACK FOOTER //
// ./src/app/tooltip/abn.directive.ts